import { render, staticRenderFns } from "./DetailBottom.vue?vue&type=template&id=db6e00b8"
import script from "./DetailBottom.vue?vue&type=script&lang=js"
export * from "./DetailBottom.vue?vue&type=script&lang=js"
import style0 from "./DetailBottom.vue?vue&type=style&index=0&id=db6e00b8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports